const FormSection = ({ step, title, subtitle, children }) => (
  <section className="form-section">
    <div className="form-section-header">
      {step && <span className="form-section-step">{step}</span>}
      <div>
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </div>
    <div className="form-section-body">{children}</div>
  </section>
);

export default FormSection;
